import React, { memo, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Tour } from '@web/web5';
import moment from 'moment';
import { ACTIVITIES } from 'constants/Entities';
import { ConfigActions } from 'actions';
import { getLiteral } from 'utils/getLiteral';

const mapStateToProps = (state) => {
    const tabsNames = state.activities?.tabsNames || [];
    return { tours: state.config.components?.tours || {}, tabsNames };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setConfigWeb: bindActionCreators(ConfigActions, dispatch).setConfigWeb,
    };
};

const ImagesAndFilesTour = memo(({ tours, setConfigWeb, tabsNames }) => {
    const hasImagesTab = useMemo(() => {
        if (!tabsNames) return false;
        const imagesTab = tabsNames.filter((tab) => tab === 'images');
        return !!imagesTab.length;
    }, [tabsNames]);

    const stepsTourImages = useMemo(() => {
        return [
            {
                selector: '#activities-detail-images-tab-title',
                title: getLiteral('label_promotion_attach_images_activities'),
                description: getLiteral('label_promotion_attach_images_activities_body'),
                event: 'tour:end',
            },
        ];
    }, []);

    const onCloseTourImages = useCallback(() => {
        const newTours = {
            ...tours,
            [ACTIVITIES.entity]: {
                ...(tours?.[ACTIVITIES.entity] || {}),
                activities_images_and_files_tab: true,
                activities_images_and_files_tab_date: moment().format(),
            },
        };
        setConfigWeb('tours', newTours);
    }, [tours, setConfigWeb]);

    if (!hasImagesTab) return null;
    return <Tour steps={stepsTourImages} delay={1000} onClose={onCloseTourImages} />;
});

export default connect(mapStateToProps, mapDispatchToProps)(ImagesAndFilesTour);
